import { AuthenticatedPolling } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { GetAvailableGitSuitesResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  isPolling: boolean
  onSuccess: (response: GetAvailableGitSuitesResponse) => void
  children?: (response: GetAvailableGitSuitesResponse) => ReactElement
}

const PollGitAvailableSuitesRequest = ({
  id,
  isPolling,
  onSuccess,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/repositories/${id}/available_suites`

  return (
    <AuthenticatedPolling
      children={children}
      intervalMs={1000}
      isPolling={isPolling}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollGitAvailableSuitesRequest
